<div id="drop-zone" class="container file-upload-container" appFileUpload (fileDropped)="onFileDropped($event)">
    <input id="file-input" #fileDropRef type="file" [disabled]="isDisabled" (change)="fileBrowseHandler($event.target.files)" multiple [accept]="allowedTypes" />
    <i class="fa-solid fa-cloud-arrow-up"></i>
    <div class="drop-zone-text">Drag and drop file here, or</div>
    <button class="btn btn-sm btn-primary btn-file-browse" (click)="fileDropRef.click()" [disabled]="isDisabled">Browse for files</button>
</div>

<div class="files-list">
    @if (fileErrors.messages.length > 0) {
        <div class="alert alert-danger" role="alert">
            <ul class="mb-0">
                @for (error of fileErrors.messages; track $index) {
                    <li [innerHTML]="error"></li>
                }
            </ul>
        </div>
    }
    @for (file of files; track $index) {
        <div class="file">
            <div class="file-icon" style="width: 30px">
                <i [class]="getFileIcon(file.type)"></i>
            </div>
            <div class="info">
                <div class="name">
                    {{ file?.name }}
                    <span class="size ms-2">({{ formatBytes($safeNavigationMigration(file?.size)) }})</span>
                </div>
                <app-progress [progress]="$safeNavigationMigration(file?.progress)"></app-progress>
            </div>
            <div class="delete" (click)="deleteFile(i)" (keypress)="deleteFile(i)">
                <i class="fa-solid fa-trash-xmark"></i>
            </div>
        </div>
    }
    @if (files.length > 0) {
        @if (files.length > 0) {
            <div class="small text-muted text-end">Files to upload {{ files.length }} of maximum {{ maxFiles }}</div>
        }
    }
</div>
